import _ from 'underscore'
import Backbone from 'backbone'
import ReportingViewTemplate from '../templates/reporting.tpl'
import HeaderView from './header'
import NavView from './nav'
import titles from '../titles'
import user from '../user'
import DateFrom from '../models/date-from'
import ReportingNameView from './reporting-name'
import StudentReportingView from './student-reporting'
import { loadView } from '../overrides';
import config from '../config';

const ReportingView = Backbone.View.extend({
    el: '#current-view',
    tagName: 'div',
    id: 'reporting-view',
    events: {
        'change .change-date-from': 'changeDateFrom',
    },
    dateFrom: null,
    initialize() {
        this.template = _.template(ReportingViewTemplate)

        // this is where we sort the dateFrom value
        this.dateFrom = new DateFrom()

        // By default it requests the results from the last seven days
        this.lastWeek()

        // Listen for changes in the titles collection:
        // - "reset" fires when you call collection.reset([...])
        // - "update" fires on add/remove
        // - "change" fires when a model's attributes change
        this.listenTo(titles, 'reset update change', this.render)
    },
    render() {
        this.$el.html(this.template())

        const headerView = new HeaderView()
        this.$('#header-view').append(headerView.render().el)

        const navView = new NavView()
        this.$('#nav-view').append(navView.render().el)

        // this loads the view which shows the username of the results being shown
        const userNameView = new ReportingNameView({model: this.model})
        this.$('#sub-view .title').prepend(userNameView.render().el)

        // load the titles
        titles.each((titleModel) => {
            // don't show titles without quizzes
            if (titleModel.get('test_available') === false) {
                return
            }

            const ResultView = loadView('result')
            const resultView = new ResultView({
                model: titleModel,
                dateFrom: this.dateFrom,
                user: this.model
            })
            this.$('.results-table').append(resultView.render().el)
        })

        // hide the students on mobile
        if (!config.get('handheld')) {
            // load the student view
            if (user.get('type').get('name') === 'teacher' &&
                user.get('role').get('name') !== null) {
                const studentView = new StudentReportingView()
                this.$('.student').append(studentView.render().el)
            } else {
                // if the user is not a teacher then student list will not load above
                // and the below code will make the results div full width, plus it will
                // hide the student div which is used to load the above view
                this.$('.results').addClass('full-width')
                this.$('.student').hide()
            }
        }

        return this
    },
    lastWeek() {
        const date = new Date()
        this.$('.change-date-from').val('lastWeek')
        this.dateFrom.set('milliseconds', date.setDate(date.getDate() - 7))
        this.model.get('results').requestResults(this.dateFrom.get('milliseconds'))
    },
    lastMonth() {
        const date = new Date()
        this.$('.change-date-from').val('lastMonth')
        this.dateFrom.set('milliseconds', date.setMonth(date.getMonth() - 1))
        this.model.get('results').requestResults(this.dateFrom.get('milliseconds'))
    },
    last6Months() {
        const date = new Date()
        this.$('.change-date-from').val('last6Months')
        this.dateFrom.set('milliseconds', date.setMonth(date.getMonth() - 6))
        this.model.get('results').requestResults(this.dateFrom.get('milliseconds'))
    },
    last12Months() {
        const date = new Date()
        this.$('.change-date-from').val('last12Months')
        this.dateFrom.set('milliseconds', date.setMonth(date.getMonth() - 12))
        this.model.get('results').requestResults(this.dateFrom.get('milliseconds'))
    },
    changeDateFrom(event) {
        // this will fire the matching dateFrom functions above
        this[event.target.value]()
    }
})

export default ReportingView
